var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9198 5.22C13.1898 4.88 13.3398 4.46 13.3398 4C13.3398 2.9 12.4398 2 11.3398 2C10.2398 2 9.33984 2.9 9.33984 4C9.33984 4.46 9.48984 4.88 9.75984 5.22",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7498 19H8.88984C8.85984 19.16 8.83984 19.33 8.83984 19.5C8.83984 20.88 9.95984 22 11.3398 22C12.1598 22 12.8798 21.61 13.3398 21C12.6498 20.48 12.0998 19.79 11.7498 19H8.88984H11.7498Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3398 12.1C17.0198 12.03 16.6798 12 16.3398 12C13.5798 12 11.3398 14.24 11.3398 17C11.3398 17.71 11.4898 18.39 11.7498 19H8.88984H3.33984L4.97984 14.89C5.21984 14.3 5.33984 13.67 5.33984 13.04V11C5.33984 7.61999 8.12984 4.89999 11.5198 4.99999C14.8098 5.09999 17.3398 7.96999 17.3398 11.25V12.1Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 22C19.1013 22 21.3398 19.7614 21.3398 17C21.3398 14.2386 19.1013 12 16.3398 12C13.5784 12 11.3398 14.2386 11.3398 17C11.3398 19.7614 13.5784 22 16.3398 22Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3398 17H19.3398",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 14V20",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e1eeff5f6f5240da584682e6171928dc.svg";
export { ForwardRef as ReactComponent };